import { useState } from "react";

import { StandardBuilderSection } from "src/sections/get-started-link-builder/standard-builder";
import { CustomBuilderSection } from "src/sections/get-started-link-builder/custom-builder";

import "./starter-pay.css";

const isGetSnugDomain =
  window.location.hostname.endsWith("getsnug.com") ||
  window.location.hostname === "localhost";

type BuilderMode = "standard" | "custom";

export default function GetStartedLinkBuilderPage() {
  const [mode, setMode] = useState<BuilderMode>(() => {
    const initial = new URLSearchParams(window.location.search).get("mode");
    return initial === "custom" ? "custom" : "standard";
  });

  if (!isGetSnugDomain) return null;

  return (
    <div className="sp-page">
      <div className="sp-brand">
        <img
          src="https://s3.us-east-2.amazonaws.com/assets.getsnug.com/files/snug_logo.png"
          alt="Snug"
          className="sp-brand-logo"
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "12px 16px 0",
        }}
      >
        <div
          className="sp-pay-schedule-options"
          role="radiogroup"
          aria-label="Builder mode"
        >
          <button
            type="button"
            role="radio"
            aria-checked={mode === "standard"}
            className={`sp-pay-schedule-option${mode === "standard" ? " is-active" : ""}`}
            onClick={() => setMode("standard")}
          >
            Standard
          </button>
          <button
            type="button"
            role="radio"
            aria-checked={mode === "custom"}
            className={`sp-pay-schedule-option${mode === "custom" ? " is-active" : ""}`}
            onClick={() => setMode("custom")}
          >
            Custom
          </button>
        </div>
      </div>

      {mode === "standard" ? <StandardBuilderSection /> : <CustomBuilderSection />}
    </div>
  );
}
